module.exports = __webpack_public_path__ + "img/gdq_gbt848_1985.prt.f5b1c480.jpg";